
if(document.querySelectorAll('.block--carousel__lower__container').length) {
  try {
    var text = document.querySelectorAll('.swiper-wrapper .swiper-slide');

    var swiper = new Swiper('.block--carousel__lower__container', {
      slidesPerView: 1,
      spaceBetween: 0,
      direction: 'horizontal',

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + text[index].attributes['data-name'].value + '</span>';
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  } catch(e) {
    console.log(e);
  }
}